import { render } from "./cardStudioEN.vue?vue&type=template&id=1f2cc66c"
import script from "./cardStudioEN.vue?vue&type=script&lang=js"
export * from "./cardStudioEN.vue?vue&type=script&lang=js"

import "./cardStudioEN.vue?vue&type=style&index=0&id=1f2cc66c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__